import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { BsArrowLeft, BsEyeSlashFill } from "react-icons/bs";
import { GiCometSpark } from "react-icons/gi";

import { Button, H3 } from "@sorcery/ui";
import { isNew } from "@sorcery/utils/universal/time";

import { useUser } from "~/providers/UserProvider";
import { deckJotai } from "~/state/deckJotai";
import { DeckModeEnum } from "~/types/deck";
import { isPrivate } from "~/utils/deck";
import { DeckActions } from "./DeckActions";

export const DeckHeader = ({ tab }: { tab: DeckModeEnum }) => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const deck = useAtomValue(deckJotai)!;
  const { user } = useUser();

  const { query: routerParams, replace } = useRouter();

  const isAuthor = useMemo(
    () => !!user && !!deck.user && user.id === deck.user.id,
    [deck.user, user],
  );

  return (
    <div className="mb-4">
      <div className="mb-2 flex flex-col justify-center text-big-text-color">
        <div className="mb-8 flex flex-row justify-start">
          {isNew(deck.createdAt) && (
            <div className="whitespace-nowrap pr-3">
              <GiCometSpark size={11} className="-mt-1 mr-1 inline text-white" />

              <span className="text-white">New</span>
            </div>
          )}

          {isPrivate(deck.visibility) && (
            <div className="whitespace-nowrap pr-3">
              <BsEyeSlashFill size={11} className="text-info -mt-[3px] mr-0.5 inline" />

              <span className="text-info">Private</span>
            </div>
          )}
        </div>
        {tab === DeckModeEnum.VIEW ? (
          <div className="flex flex-col md:flex-row">
            {/* if author  */}
            {isAuthor && (
              <Button
                className="mr-6 w-fit"
                variant="outline"
                onClick={() => {
                  void replace(
                    {
                      query: {
                        ...routerParams,
                        tab: DeckModeEnum.EDIT,
                      },
                    },
                    undefined,
                    {
                      shallow: true,
                    },
                  );
                }}
              >
                <H3 className="inline whitespace-nowrap mb-0">Edit Mode</H3>
              </Button>
            )}
            <DeckActions />
          </div>
        ) : (
          <Button
            variant="outline"
            className="w-fit"
            onClick={() => {
              void replace(
                {
                  query: {
                    ...routerParams,
                    tab: DeckModeEnum.VIEW,
                  },
                },
                undefined,
                {
                  shallow: true,
                },
              );
            }}
          >
            <BsArrowLeft size={30} className="-mt-1 mr-1 inline" />
            <H3 className="inline mb-0">
              <span>Back&nbsp;</span>
              <span className="hidden sm:inline">to Decklist</span>
            </H3>
          </Button>
        )}
      </div>
    </div>
  );
};
